import { mockApi } from "./mockApi.js";

// Mock API handlers for RTK Query
export const mockHandlers = (builder) => ({
  // Posts endpoints
  getPosts: builder.query({
    queryFn: async () => {
      try {
        // Fetch posts from JSONPlaceholder
        const response = await fetch(
          "https://jsonplaceholder.typicode.com/posts?_limit=10"
        );
        const posts = await response.json();
        return { data: posts };
      } catch (error) {
        return { error: { status: "FETCH_ERROR", error: error.message } };
      }
    },
  }),

  getPost: builder.query({
    queryFn: async (postId) => {
      try {
        // Fetch post from JSONPlaceholder
        const response = await fetch(
          `https://jsonplaceholder.typicode.com/posts/${postId}`
        );
        const post = await response.json();
        return { data: post };
      } catch (error) {
        return { error: { status: "FETCH_ERROR", error: error.message } };
      }
    },
  }),

  // Auth endpoints
  login: builder.mutation({
    queryFn: async (credentials) => {
      try {
        const result = await mockApi.login(
          credentials.username,
          credentials.password
        );
        return { data: result };
      } catch (error) {
        return { error: { status: 401, data: error.message } };
      }
    },
  }),

  register: builder.mutation({
    queryFn: async (userData) => {
      try {
        const result = await mockApi.register(userData);
        return { data: result };
      } catch (error) {
        return { error: { status: 400, data: error.message } };
      }
    },
  }),

  forgotPassword: builder.mutation({
    queryFn: async ({ email }) => {
      try {
        const result = await mockApi.forgotPassword(email);
        return { data: result };
      } catch (error) {
        return { error: { status: 404, data: error.message } };
      }
    },
  }),

  resetPassword: builder.mutation({
    queryFn: async (data) => {
      try {
        const result = await mockApi.resetPassword(data);
        return { data: result };
      } catch (error) {
        return { error: { status: 400, data: error.message } };
      }
    },
  }),

  changePassword: builder.mutation({
    queryFn: async (data) => {
      try {
        const result = await mockApi.changePassword(data);
        return { data: result };
      } catch (error) {
        return { error: { status: 400, data: error.message } };
      }
    },
  }),

  // User endpoints
  getCurrentUser: builder.query({
    queryFn: async (_, { getState }) => {
      try {
        const token = getState().auth.token;
        const user = await mockApi.getCurrentUser(token);
        return { data: user };
      } catch (error) {
        return { error: { status: 401, data: error.message } };
      }
    },
  }),

  updateProfile: builder.mutation({
    queryFn: async (userData) => {
      try {
        const result = await mockApi.updateProfile(userData);
        return { data: result };
      } catch (error) {
        return { error: { status: 400, data: error.message } };
      }
    },
  }),

  getUsers: builder.query({
    queryFn: async () => {
      try {
        const users = await mockApi.getUsers();
        return { data: users };
      } catch (error) {
        return { error: { status: 403, data: error.message } };
      }
    },
  }),
});
